import React from 'react'
import Skeleton from 'react-loading-skeleton'

function SkeletonAuditScore(){
    return <div className="card border-0 text-truncate">
        <div className="card-body">
            <div className="row d-flex justify-content-between" style={{height:"30px"}}>
                <div className="col-sm-6 col mb-1 f-s-16">
                    <b className="mb-3"><Skeleton height={15} /></b>
                </div>
                <div className="col-sm-6 col mb-1 f-s-16 visual-component">
                    <Skeleton height={30} width={60} style={{float: "right"}} />
                </div>
            </div>
            <div className="d-flex align-items-end justify-content-center">
                <div className="mr-4">
                    <Skeleton circle height={100} width={120} />
                </div>
                <div>
                    <Skeleton circle height={125} width={130} />
                </div>
            </div>
            <hr style={{marginTop: 0, marginBottom: 0}} />
            <div className="d-flex align-items-end justify-content-center">
                <h4  className="mr-4 text-center" style={{width: "120px", lineHeight: "30px"}}>
                    <Skeleton width="100%" height={40} />
                </h4>
                <h4 className="text-center" style={{width: "130px", lineHeight: "30px"}}>
                    <Skeleton width="100%" height={40} />
                </h4>
            </div>
        </div>
    </div>
}

export default SkeletonAuditScore